export default function getFileTypeFromB64(b64){const arr=b64.split(',');const mime=arr[0].match(/:(.*?);/)[1];// image/png
return mime.split('/')[1];}